const MenuList = [
  {
    Menulink: "#Settings",
    color: "#8be9fd",
    MenuName: "SETTINGS"
  },
  {
    Menulink: "#GISTS",
    color: "background-color:$GISTS",
    bgcolor: "color:$GISTS",
    MenuName: "GISTS"
  },
  {
    Menulink: "#STACKOVERFLOW",
    color: "background-color:$STACKOVERFLOW",
    bgcolor: "color:$STACKOVERFLOW",
    MenuName: "STACK OVERFLOW"
  },
  {
    Menulink: "#SEARCHPAD",
    color: "background-color:$SEARCHPAD",
    bgcolor: "color:$SEARCHPAD",
    MenuName: "SEARCH PAD"
  },
  {
    Menulink: "#PLAYGROUND",
    color: "background-color:$PLAYGROUND",
    bgcolor: "color:$PLAYGROUND",
    MenuName: "PLAYGROUND",
    lock: "lock"
  },
  {
    Menulink: "#HELP",
    color: "background-color:$HELP",
    bgcolor: "color:$HELP",
    MenuName: "HELP/INTRO"
  }
];
const PopularList = [
  {
    PLcontent:
      "A teacher at my school was sick of remembering all the different bell schedules, so I created an app to make things easier. The whole school loves it.",
    PLname: "u/scheduled_nightmare",
    PLnumber: "259"
  },
  {
    PLcontent:
      "I created this visual Flex editor entirely in vanilla JavaScript and explained step by step how I did it (see walk-thru tutorial in comments). Allegedly, it has been used in multiple classrooms to teach CSS.",
    PLname: "u/gregsometimes",
    PLnumber: "112"
  },
  {
    PLcontent:
      "Single Dashboard built with Javascript to identify cost savings on both AWS and GCP",
    PLname: "u/labouardy",
    PLnumber: "19"
  },
  {
    PLcontent: "What’s the best way to learn JavaScript?",
    PLname: "u/AYawningPerson",
    PLnumber: "8"
  },
  {
    PLcontent: "JavaScript's for loop is surprisingly fast",
    PLname: "u/TurnaroundGames",
    PLnumber: "142"
  },
  {
    PLcontent: "How does the browser highlight text during 'find' ?",
    PLname: "u/brainhack3r",
    PLnumber: "3"
  },
  {
    PLcontent:
      "I wrote WebRTC Chat examples for React and native HTML web components.",
    PLname: "u/_vardius",
    PLnumber: "2"
  },
  {
    PLcontent: "CRUI: Composable Reactive UI — Preview",
    PLname: "u/Iazel",
    PLnumber: "1"
  },
  {
    PLcontent: "great article to know about async programming in node js",
    PLname: "u/h_sa1994",
    PLnumber: "162"
  }
];

const JSHistoryList = [
  {
    JSlink:
      "https://javascript.programmer-reference.com/js-string-fromcharcode/",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://javascript.programmer-reference.com/js-string-fromcharcode/",
    JScontent:
      "[JavaScript] ASCIIコードから文字列に変換する（String.fromCharCode） – コピペで使える JavaScript逆引きリファレンス",
    JSdate: "1"
  },
  {
    JSlink:
      "https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Operadores/Spread_operator",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Operadores/Spread_operator",
    JScontent: "Operador de propagación - JavaScript | MDN",
    JSdate: "1"
  },
  {
    JSlink: "https://techacademy.jp/magazine/5562",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://techacademy.jp/magazine/5562",
    JScontent:
      "JavaScriptでメソッドを使う方法【初心者向け】 | TechAcademyマガジン",
    JSdate: "2"
  },
  {
    JSlink: "https://glorificatio.org/archives/1921",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://glorificatio.org/archives/1921",
    JScontent:
      "今更聞けない 三分で分かるJavaScriptの基本的な関数の書き方 | Divide et impera",
    JSdate: "2"
  },
  {
    JSlink: "https://javascript.programmer-reference.com/js-string-regexp/",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://javascript.programmer-reference.com/js-string-regexp/",
    JScontent:
      "[JavaScript] ASCIIコードから文字列に変換する（String.fromCharCode） – コピペで使える JavaScript逆引きリファレンス",
    JSdate: "2"
  },
  {
    JSlink: "https://prog-8.com/es6/study/1/5#",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://prog-8.com/es6/study/1/5#",
    JScontent:
      "JavaScript 学習コース Ⅰ | プログラミングの入門なら基礎から学べるProgate[プロゲート]",
    JSdate: "3"
  },
  {
    JSlink:
      "https://sites.google.com/site/jqueryjavascript/setintervaltoclearintervalno-shii-fang",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://sites.google.com/site/jqueryjavascript/setintervaltoclearintervalno-shii-fang",
    JScontent:
      "setIntervalとclearIntervalの使い方 - jQuery(javascript)の使い方",
    JSdate: "3"
  },
  {
    JSlink: "https://prog-8.com/es6/study/1/5#",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://prog-8.com/es6/study/1/5#",
    JScontent:
      "JavaScript 学習コース Ⅰ | プログラミングの入門なら基礎から学べるProgate[プロゲート]",
    JSdate: "3"
  },
  {
    JSlink:
      "https://www.google.com/search?q=javascript+%E5%85%A8%E9%83%A8%E5%A4%A7%E6%96%87%E5%AD%97%E3%81%8B%E7%A2%BA%E8%AA%8D&rlz=1C1CHBF_enJP761JP761&oq=javascript+%E5%85%A8%E9%83%A8%E5%A4%A7%E6%96%87%E5%AD%97%E3%81%8B%E7%A2%BA%E8%AA%8D&aqs=chrome..69i57j33.17582j0j7&sourceid=chrome&ie=UTF-8",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://javascript.programmer-reference.com/js-string-regexp/",
    JScontent: "javascript 全部大文字か確認 - Buscar con Google",
    JSdate: "4"
  },
  {
    JSlink: "https://news.mynavi.jp/article/20110531-chrome/",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://news.mynavi.jp/article/20110531-chrome/",
    JScontent:
      "Chromeの知られざる開発者向け機能 - JavaScriptメモリ消費量の解析 | マイナビニュース",
    JSdate: "4"
  },
  {
    JSlink: "https://news.mynavi.jp/article/20110531-chrome/",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://news.mynavi.jp/article/20110531-chrome/",
    JScontent:
      "Chromeの知られざる開発者向け機能 - JavaScriptメモリ消費量の解析 | マイナビニュース",
    JSdate: "4"
  },
  {
    JSlink: "https://news.mynavi.jp/article/20110531-chrome/",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://news.mynavi.jp/article/20110531-chrome/",
    JScontent:
      "Chromeの知られざる開発者向け機能 - JavaScriptメモリ消費量の解析 | マイナビニュース",
    JSdate: "4"
  },
  {
    JSlink: "https://news.mynavi.jp/article/20110531-chrome/",
    JSimg:
      "https://www.google.com/s2/favicons?domain=https://news.mynavi.jp/article/20110531-chrome/",
    JScontent:
      "Chromeの知られざる開発者向け機能 - JavaScriptメモリ消費量の解析 | マイナビニュース",
    JSdate: "4"
  }
];

const GithubHistoryList = [
  {
    GHrepo: "GoogleChrome/puppeteer",
    GHnumber: "1341",
    GHcontent:
      "How to get the inner text of elements from the return values of page.$$"
  },
  {
    GHrepo: "GoogleChrome/puppeteer",
    GHnumber: "3051",
    GHcontent: "How to get text from a element ?"
  },
  {
    GHrepo: "apollographql/graphql-tag",
    GHnumber: "131",
    GHcontent: "Parse variables"
  },
  {
    GHrepo: "apollographql/apollo-client",
    GHnumber: "3967",
    GHcontent: "It is not possibile to pass Authorization header to WebSocket"
  },
  {
    GHrepo: "GoogleChrome/puppeteer",
    GHnumber: "1341",
    GHcontent:
      "How to get the inner text of elements from the return values of page.$$"
  },
  {
    GHrepo: "GoogleChrome/puppeteer",
    GHnumber: "1341",
    GHcontent:
      "How to get the inner text of elements from the return values of page.$$"
  },
  {
    GHrepo: "GoogleChrome/puppeteer",
    GHnumber: "1341",
    GHcontent:
      "How to get the inner text of elements from the return values of page.$$"
  },
  {
    GHrepo: "GoogleChrome/puppeteer",
    GHnumber: "1341",
    GHcontent:
      "How to get the inner text of elements from the return values of page.$$"
  },
  {
    GHrepo: "GoogleChrome/puppeteer",
    GHnumber: "1341",
    GHcontent:
      "How to get the inner text of elements from the return values of page.$$"
  }
];

export { PopularList, JSHistoryList, GithubHistoryList };
